import { Button } from '@/components';

import styles from './FiltersModal.module.scss';
import { useOpenSearch, useRefinementsHelpers } from 'opensearch/hooks';

const FiltersModalFooter = ({ onClose }) => {
  const { clearAllFilters } = useRefinementsHelpers();
  const { totalHits } = useOpenSearch();

  return (
    <div className={styles.filters_footer}>
      <Button
        className={styles.clear_button}
        color="secondary"
        onClick={clearAllFilters}
      >
        Clear filters
      </Button>
      {!!totalHits && (
        <Button
          className={styles.results_button}
          color="primary"
          onClick={onClose}
        >
          See results
        </Button>
      )}
    </div>
  );
};

export { FiltersModalFooter };
